import { render } from "./RatingsCard.vue?vue&type=template&id=27bdda5d&scoped=true"
import script from "./RatingsCard.vue?vue&type=script&lang=js"
export * from "./RatingsCard.vue?vue&type=script&lang=js"

import "./RatingsCard.vue?vue&type=style&index=0&id=27bdda5d&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bdda5d"]])

export default __exports__